import { HeidiVersion } from '@heidi/schema/ml-scribe';

import type { Heidi2WelcomeOutcome } from '../../../data/heidi-2';

export interface Heidi2ActivatedWelcomeGate {
  isHeidi2OnboardingEnabled: boolean;
  /** Launch queue has evaluated, with billing info fetched on this load. */
  isClinicianTrialEligibilityLoaded: boolean;
  /** False during workspace-switch reload. */
  isWorkspaceIdSettled: boolean;
  /** Includes paused + Chronicle. */
  isClinicalRecordingActive: boolean;
  isClinicianTrialModalBlocking: boolean;
  /** `user.is_managed`; unknown while loading counts as managed. */
  isUserManaged: boolean | null | undefined;
  hasTeam: boolean;
  heidiVersion: HeidiVersion | null | undefined;
  welcomeOutcome: Heidi2WelcomeOutcome;
}

/**
 * Anyone on a team someone else already moved to Heidi II, admin or not, who
 * has not been through the welcome. A revoked member reads as Heidi 1, so
 * they drop out here.
 */
export const computeShouldShowHeidi2ActivatedWelcome = (
  gate: Heidi2ActivatedWelcomeGate
): boolean =>
  gate.isHeidi2OnboardingEnabled &&
  gate.isClinicianTrialEligibilityLoaded &&
  gate.isWorkspaceIdSettled &&
  !gate.isClinicalRecordingActive &&
  !gate.isClinicianTrialModalBlocking &&
  gate.isUserManaged === false &&
  gate.hasTeam &&
  gate.heidiVersion === HeidiVersion.Value2 &&
  gate.welcomeOutcome === 'unseen';
